import {
    HttpEvent,
    HttpHandler,
    HttpInterceptor,
    HttpRequest,
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { finalize, retry, tap } from 'rxjs/operators';
import { LocalStorageService } from './../../core/services/local-storage.service';
import { LoadingIndicatorService } from './loading-indicator.service';

@Injectable({ providedIn: 'root' })
export class HttpInterceptorService implements HttpInterceptor {
    skipURL: Array<string>;
    count = 0;
    countGlobalSpinner = 0;

    constructor(
        private service: LoadingIndicatorService,
        private storage: LocalStorageService
    ) {}

    intercept(
        req: HttpRequest<any>,
        next: HttpHandler
    ): Observable<HttpEvent<any>> {
        const reqId = req.headers.get('reqId');
        const customId = req.headers.get('customId');
        if (reqId && !req.headers.get('skipLoader')) {
            if (this.count === 0) {
                this.service.startLoading(reqId, customId);
            }
            this.count++;
        } else if (!req.headers.get('skipLoader')) {
            if (this.countGlobalSpinner === 0) {
                this.service.startGlobalLoading();
            }
            this.countGlobalSpinner++;
        }

        const reqWithToken = req.clone({
            setHeaders: {
                Authorization: `Bearer ${this.storage.getToken()}`,
                taxNumber: this.storage.getTaxNumber(),
                notaryTaxNumber: this.storage.getTaxNumber(),
                role: this.storage.getRole(),
            },
        });
        return next.handle(reqWithToken).pipe(
            retry(req.headers.get('skipRetry') ? 0 : 3),
            tap((event) => {}),
            finalize(() => {
                if (reqId && !req.headers.get('skipLoader')) {
                    this.count--;
                    if (this.count === 0) {
                        this.service.stopLoading(reqId, customId);
                    }
                } else if (!req.headers.get('skipLoader')) {
                    this.countGlobalSpinner--;
                    if (this.countGlobalSpinner === 0) {
                        this.service.stopGlobalLoading();
                    }
                }
            })
        );
    }
}
